// @flow

import timelapse_1 from "./timelapse_1.jpg"
import timelapse_2 from "./timelapse_2.jpg"
import timelapse_3 from "./timelapse_3.jpg"
import timelapse_4 from "./timelapse_4.jpg"
import timelapse_5 from "./timelapse_5.jpg"
import timelapse_6 from "./timelapse_6.jpg"
import timelapse_7 from "./timelapse_7.jpg"
import timelapse_8 from "./timelapse_8.jpg"
import timelapse_9 from "./timelapse_9.jpg"
import timelapse_10 from "./timelapse_10.jpg"
import timelapse_11 from "./timelapse_12.jpg"
import timelapse_12 from "./timelapse_12.jpg"
import timelapse_13 from "./timelapse_13.jpg"
import timelapse_14 from "./timelapse_14.jpg"
import timelapse_15 from "./timelapse_15.jpg"
import timelapse_16 from "./timelapse_16.jpg"
import timelapse_17 from "./timelapse_17.jpg"
import timelapse_18 from "./timelapse_18.jpg"
import timelapse_19 from "./timelapse_19.jpg"
import timelapse_20 from "./timelapse_20.jpg"
import timelapse_21 from "./timelapse_21.jpg"
import timelapse_22 from "./timelapse_22.jpg"
import timelapse_23 from "./timelapse_23.jpg"
import timelapse_24 from "./timelapse_24.jpg"
import timelapse_25 from "./timelapse_25.jpg"
import timelapse_26 from "./timelapse_26.jpg"
import timelapse_27 from "./timelapse_27.jpg"
import timelapse_28 from "./timelapse_28.jpg"
import timelapse_29 from "./timelapse_29.jpg"
import timelapse_30 from "./timelapse_30.jpg"
import timelapse_31 from "./timelapse_31.jpg"
import timelapse_32 from "./timelapse_32.jpg"
import timelapse_33 from "./timelapse_33.jpg"

export default [
  timelapse_1,
  timelapse_2,
  timelapse_3,
  timelapse_4,
  timelapse_5,
  timelapse_6,
  timelapse_7,
  timelapse_8,
  timelapse_9,
  timelapse_10,
  timelapse_11,
  timelapse_12,
  timelapse_13,
  timelapse_14,
  timelapse_15,
  timelapse_16,
  timelapse_17,
  timelapse_18,
  timelapse_19,
  timelapse_20,
  timelapse_21,
  timelapse_22,
  timelapse_23,
  timelapse_24,
  timelapse_25,
  timelapse_26,
  timelapse_27,
  timelapse_28,
  timelapse_29,
  timelapse_30,
  timelapse_31,
  timelapse_32,
  timelapse_33
]



// WEBPACK FOOTER //
// ./src/Kiosk/WoodburningView/images.js